import {
  ArticleHeading1,
  ArticleHeading2,
  ArticleHeading3,
  ArticleHeading4,
  ArticleHeading5,
  ArticleHeading6,
} from '@cian/ui-kit';
import { COMMON_COMPONENT_PROPS } from '../const';

export const articleHeadings = {
  ArticleHeading1: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleHeading1',
    component: ArticleHeading1,
    tagName: 'articleheading1',
    block: {
      label: 'ArticleHeading1',
      category: 'Article Typography',
      content: '<ArticleHeading1>ArticleHeading1</ArticleHeading1>',
    },
  },

  ArticleHeading2: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleHeading2',
    component: ArticleHeading2,
    tagName: 'articleheading2',
    block: {
      label: 'ArticleHeading2',
      category: 'Article Typography',
      content: '<ArticleHeading2>ArticleHeading2</ArticleHeading2>',
    },
  },

  ArticleHeading3: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleHeading3',
    component: ArticleHeading3,
    tagName: 'articleheading3',
    block: {
      label: 'ArticleHeading3',
      category: 'Article Typography',
      content: '<ArticleHeading3>ArticleHeading3</ArticleHeading3>',
    },
  },

  ArticleHeading4: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleHeading4',
    component: ArticleHeading4,
    tagName: 'articleheading4',
    block: {
      label: 'ArticleHeading4',
      category: 'Article Typography',
      content: '<ArticleHeading4>ArticleHeading4</ArticleHeading4>',
    },
  },

  ArticleHeading5: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleHeading5',
    component: ArticleHeading5,
    tagName: 'articleheading5',
    block: {
      label: 'ArticleHeading5',
      category: 'Article Typography',
      content: '<ArticleHeading5>ArticleHeading5</ArticleHeading5>',
    },
  },

  ArticleHeading6: {
    ...COMMON_COMPONENT_PROPS,
    id: 'articleHeading6',
    component: ArticleHeading6,
    tagName: 'articleheading6',
    block: {
      label: 'ArticleHeading6',
      category: 'Article Typography',
      content: '<ArticleHeading6>ArticleHeading6</ArticleHeading6>',
    },
  },
};
